import { PrimaryArrowButton, SecondaryArrowButton, SubTitle2 } from '@rikstv/shared-components';
import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';
import { trackClickInternetCTA } from '~/analytics/eventTracker';
import { Card } from '~/components/shared';
import { FlexBox } from '~/components/shared/layout/FlexBox';
import { useIsMobileView } from '~/hooks/useMediaQuery';
import { v2Routes } from '../../v2/v2routes';

import classes from '../InternetOfferSubPage.module.css';
import { useLazySanityData } from '../hooks/useLazySanityData';

export const TvPackageOnlyCard = ({ noInternetPackages }: { noInternetPackages?: boolean }) => {
  const navigate = useNavigate();
  const isMobile = useIsMobileView();
  const {
    displayData: { tvOnlyTitle, tvOnlyDescription },
  } = useLazySanityData();
  const btnLabel = 'Se våre TV-pakker';
  const BtnComponent = noInternetPackages ? PrimaryArrowButton : SecondaryArrowButton;
  return (
    <Card>
      <FlexBox wrap={false} alignItems="center" direction={isMobile ? 'column' : undefined}>
        <FlexBox direction="column" style={{ flex: 1 }} alignItems={isMobile ? 'center' : undefined}>
          <SubTitle2>{tvOnlyTitle}</SubTitle2>
          <span>{tvOnlyDescription}</span>
        </FlexBox>
        <BtnComponent
          className={classNames({ [classes.whiteSecondaryBtn]: !noInternetPackages })}
          onClick={() => {
            trackClickInternetCTA({ link_text: btnLabel, ngt_available: true, link_url: location.origin + v2Routes.index });
            navigate(v2Routes.index);
          }}
        >
          {btnLabel}
        </BtnComponent>
      </FlexBox>
    </Card>
  );
};
